import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { Modal, CppEstimator } from 'components';
import { Planning } from 'actions';

class CppModal extends Component {
  state = {
    tableOpen: false,
  };

  setTableOpen = (tableOpen) => this.setState({ tableOpen });

  updateInfo = (
    yearsWorked,
    caregiver,
    yearsCare,
    exceedIncome,
    exceedIncomeBy
  ) => {
    const { dispatch, isCouple } = this.props;
    if (isCouple) {
      dispatch(
        Planning.updateBlueprintData('personalDetails', {
          years_contrib2: yearsWorked,
          primary_caregiver2: caregiver,
          years_primary_caregiver2: yearsCare,
          is_earning_over_average2: exceedIncome,
          perc_under_average2: exceedIncomeBy,
        })
      );
    } else {
      dispatch(
        Planning.updateBlueprintData('personalDetails', {
          years_contrib: yearsWorked,
          primary_caregiver: caregiver,
          years_primary_caregiver: yearsCare,
          is_earning_over_average: exceedIncome,
          perc_under_average: exceedIncomeBy,
        })
      );
    }
  };

  render() {
    const {
      isOpen,
      toggle,
      updateCppInfo,
      cppDataset,
      isCouple,
      personalDetails,
    } = this.props;
    const { tableOpen } = this.state;

    const { age, age2 } = personalDetails || {};
    const {
      years_contrib,
      primary_caregiver,
      years_primary_caregiver,
      is_earning_over_average,
      perc_under_average,
      years_contrib2,
      primary_caregiver2,
      years_primary_caregiver2,
      is_earning_over_average2,
      perc_under_average2,
      cppAge,
      cppAge2,
      province,
    } = personalDetails || {};

    const personalDetailsCpp = {
      years_contrib: isCouple ? years_contrib2 : years_contrib,
      primary_caregiver: isCouple ? primary_caregiver2 : primary_caregiver,
      years_primary_caregiver: isCouple
        ? years_primary_caregiver2
        : years_primary_caregiver,
      is_earning_over_average: isCouple
        ? is_earning_over_average2
        : is_earning_over_average,
      perc_under_average: isCouple ? perc_under_average2 : perc_under_average,
      cppAge: isCouple ? cppAge2 : cppAge,
    };

    return (
      <Modal open={isOpen} dimmerClick={() => !tableOpen && toggle(false)}>
        <Modal.Content
          style={{
            position: 'relative',
            padding: '2rem',
            backgroundColor: 'white',
          }}
        >
          <CloseIcon onClick={() => toggle(false)}>+</CloseIcon>

          <CppEstimator
            cppAge={cppAge}
            toggle={toggle}
            updateCppInfo={updateCppInfo}
            cppDataset={cppDataset}
            setTableOpen={this.setTableOpen}
            clientAge={isCouple ? age2 : age}
            clientProvince={province}
            personalDetails={personalDetailsCpp}
            updateInfo={this.updateInfo}
            closeModal={() => toggle(false)}
          />
        </Modal.Content>
      </Modal>
    );
  }
}

CppModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isCouple: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  updateCppInfo: PropTypes.func,
  cppDataset: PropTypes.array,
  personalDetails: PropTypes.object,
  dispatch: PropTypes.func,
};

CppModal.defaultProps = {
  updateCppInfo: () => false,
  cppDataset: [],
  personalDetails: {},
  dispatch: () => false,
};

export default connect((state) => ({
  personalDetails: state.Planning.blueprint.personalDetails,
}))(CppModal);

const CloseIcon = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  height: 20px;
  width: 20px;
  text-align: center;
  font-size: 1.7rem;
  border-radius: 50%;
  line-height: 19px;
  transform: rotate(45deg);
  transition: all 0.1s ease;
  cursor: pointer;

  &:hover {
    background: rgba(0, 0, 0, 0.8);
    color: #fff6f6;
  }
`;
